import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLang } from "../context/LangContext";

const IMG1 = "https://images.unsplash.com/photo-1599071338288-49173359e0fd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000";
const IMG2 = "https://images.unsplash.com/photo-1609619742069-f5e18afeef17?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000";

export default function About() {
  const { t } = useLang();
  return (
    <div data-testid="about-page" className="pt-40 pb-24 min-h-screen">
      <div className="max-w-4xl mx-auto px-6 mb-20">
        <p className="overline text-brand-primary mb-4">{t("about_overline")}</p>
        <h1 className="font-heading text-5xl md:text-7xl font-light tracking-tighter text-ink leading-[0.95]">{t("about_title")}</h1>
      </div>

      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 md:gap-20 items-center mb-24">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }} className="overflow-hidden aspect-[4/5]">
          <img src={IMG1} alt="Artesanía" className="w-full h-full object-cover" />
        </motion.div>
        <div>
          <p className="text-ink-soft text-lg leading-relaxed mb-6">{t("about_p1")}</p>
          <p className="text-ink-soft text-lg leading-relaxed">{t("about_p2")}</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 md:gap-20 items-center">
        <div className="order-2 md:order-1">
          <p className="overline text-brand-primary mb-4">{t("hero_overline")}</p>
          <h2 className="font-heading text-4xl font-light tracking-tight text-ink mb-6">{t("hero_title")}</h2>
          <p className="text-ink-soft leading-relaxed mb-8">{t("hero_sub")}</p>
          <Link to="/tienda" data-testid="about-shop-btn" className="inline-block bg-brand-primary text-white px-8 py-4 text-sm uppercase tracking-wide hover:bg-brand-dark transition-colors">
            {t("hero_cta")}
          </Link>
        </div>
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }} className="order-1 md:order-2 overflow-hidden aspect-[4/5]">
          <img src={IMG2} alt="Herramientas" className="w-full h-full object-cover" />
        </motion.div>
      </div>
    </div>
  );
}
